export default defineNuxtRouteMiddleware(async (to) => {
  const config = useRuntimeConfig()

  if (config.public.FREE_WEEKEND_ENABLED === 'true') {
    await useFreeWeekend().init()
  }
})
